import { render } from "./articleIndex.vue?vue&type=template&id=d8e35cd6"
import script from "./articleIndex.vue?vue&type=script&lang=js"
export * from "./articleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__